var l64 = {
    code: 'sm',
    buttonText: {
        prev: 'Talu ai',
        next: 'Mulimuli atu',
        today: 'Aso nei',
        year: 'Tausaga',
        month: 'Masina',
        week: 'Vaiaso',
        day: 'Aso',
        list: 'Faasologa',
    },
    weekText: 'Vaiaso',
    allDayText: 'Aso atoa',
    moreLinkText: 'sili atu',
    noEventsText: 'Leai ni mea na tutupu',
};

export { l64 as default };
